import React from 'react';
import './AboutUs.css';

/**
 * People involved in Breaking Barriers & Building Opportunity / LMS (display order preserved).
 */
const PROJECT_TEAM = [
  { name: 'Roopali Chaudhary, PhD', affiliation: 'Founder, Lotus STEMM'},
  { name: 'Gayathri Shukla', affiliation: 'Campfire Kinship' },
  { name: 'Anjali Barak', affiliation: 'Lotus STEMM' },
  { name: 'Nikhil Gaikwad', affiliation: 'Lotus STEMM' },
  { name: 'Stelth Ng', affiliation: 'Triple Pointe Media Production' },
  { name: 'Richard Rosenman', affiliation: 'Hatch Studios Ltd.' },
  { name: 'Hajar Moradi', affiliation: 'Vivido Inc.' },
  { name: 'Caroline Claussen', affiliation: 'C3 Inc.' },
  { name: 'Dr. Rida Abboud', affiliation: 'Rida Abboud Consulting' },
  { name: 'Bhavya Abbi', affiliation: 'Lotus STEMM' },
  { name: 'Sanzida Shams', affiliation: 'Lotus STEMM' },
  { name: 'Harman Kaur', affiliation: 'Lotus STEMM' },
  { name: 'Malika Seth', affiliation: 'Lotus STEMM' },
  { name: 'Jiya Prajapati', affiliation: 'Lotus STEMM' },
  { name: 'Tisya Pramanik', affiliation: 'Lotus STEMM' },
];

export default function AboutUs() {
  return (
    <div className="about-page">
      <header className="about-hero">
        <h1 className="about-page-title">About us</h1>
        <p className="about-page-subtitle">
          Assume We Can (formerly Breaking Barriers &amp; Building Opportunity) is a collaborative learning and research initiative.
          The following people and organizations have contributed to this platform and the wider project.
        </p>
      </header>

      <div className="about-container">
        <section className="about-section" aria-labelledby="about-team-heading">
          <h2 id="about-team-heading" className="about-section-title">
            Project team
          </h2>
          <p className="about-section-lead">
            Researchers, partners, and contributors who helped shape this LMS and the stories, tools, and resources
            you explore here.
          </p>

          <ul className="about-team-grid">
            {PROJECT_TEAM.map((person) => (
              <li key={person.name} className="about-team-card">
                <div className="about-team-card-accent" aria-hidden="true" />
                <div className="about-team-card-body">
                  <span className="about-team-name">{person.name}</span>
                  {person.affiliation ? (
                    <span className="about-team-affiliation">{person.affiliation}</span>
                  ) : null}
                </div>
              </li>
            ))}
          </ul>
        </section>

        <section className="about-footnote" aria-label="Partners">
          <p>
            <strong>Lotus STEMM</strong> and <strong>Campfire Kinship</strong> acknowledge every contributor and community members who informed this work.
          </p>
        </section>
      </div>
    </div>
  );
}
